import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const TableLink = ({
  href, className, onClick, renderData,
}) => {
  const linkRef = useRef(null);
  useEffect(() => {
    const el = linkRef.current;
    if (!el || !className?.includes('truncate')) return undefined;
    const handleMouseEnter = (e) => {
      if (e.target.offsetWidth < e.target.scrollWidth) {
        e.target.setAttribute('title', renderData);
      } else {
        e.target.removeAttribute('title');
      }
    };
    el.addEventListener('mouseenter', handleMouseEnter);
    // Cleanup event listener on unmount
    return () => {
      el.removeEventListener('mouseenter', handleMouseEnter);
    };
  }, [className, renderData]);

  return (
    <a
      ref={linkRef}
      href={href}
      className={className}
      onClick={onClick}
    >
      {renderData}
    </a>
  );
};

TableLink.propTypes = {
  href: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  renderData: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

export default TableLink;
